var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workorder-specific-info-card" },
    [
      _c("tabs", {
        attrs: {
          tabs: _vm.tabs,
          "active-tab": _vm.activeTab,
          "tabs-styling": _vm.tabsStyling,
          "tabs-labels-styling": _vm.tabsLabelsStyling,
          "center-tabs": false
        },
        on: {
          startTabChange: function($event) {
            _vm.activeTab = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          style: {
            height: "100%",
            "padding-top": "17px",
            "overflow-y": "auto",
            "overflow-x": "hidden"
          }
        },
        [
          _c("management-map", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === 0,
                expression: "activeTab === 0"
              }
            ],
            style: { height: "calc(100% - 50px)" }
          }),
          _vm._v(" "),
          _c("Table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === 1,
                expression: "activeTab === 1"
              }
            ],
            attrs: {
              tableLines: true,
              checkbox: false,
              loading: false,
              headers: _vm.headers,
              items: _vm.workorderObjects,
              sortable: false,
              emitRowClickBusEvent: false
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be60b146", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be60b146","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/TasksManagement/WorkorderSpecificInfo.vue
// module id = null
// module chunks = 